/**
 * Describes the format of the PriceMovementValue(1921).
 * tag: 1923
 * @readonly
 * @enum {number} (int)
 */
export enum PriceMovementType {
  /** Amount */
  Amount = 0,
  /** Percentage */
  Percentage = 1,
}
